export const MEMBERSHIP_COMPARE_DISPLAY_VARIANT = {
  default: "default",
  checkout: "checkout",
} as const;
